module.exports = __webpack_public_path__ + "img/左哼哼.4ac97da5.gif";